import { Container, Stack, Typography } from "@mui/material";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import type { OperationStatus } from "./importDataPagesTypes";

interface Props {
  title: string;
  operationStatus: OperationStatus;
}

const FullPageStatusProgress = ({ title, operationStatus }: Props) => {
  const { statusText, details, error } = operationStatus;

  return (
    <Container sx={{ height: "100%" }}>
      <Stack sx={{ justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <InlineLoader />
          <Typography color="textSecondary" sx={{ textAlign: "center" }}>
            {title}
          </Typography>
          <Stack spacing={1} sx={{ alignItems: "flex-start", height: "12rem", mt: 2 }}>
            {error ? (
              <Typography variant="subtitle2" color="error">
                {error}
              </Typography>
            ) : (
              <Typography variant="subtitle2">{statusText}</Typography>
            )}
            {details.map(([key, value]) => (
              <Stack key={key} direction="row" spacing={1} sx={{ width: "100%" }}>
                <Typography color="textSecondary" sx={{ width: "8rem" }}>
                  {key}
                </Typography>
                <Typography>{value}</Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default FullPageStatusProgress;
